module.exports = __webpack_public_path__ + "img/24.a4b83292.svg";